const getters = {
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userinfo: state => state.user.userinfo,
  config: state => state.user.config,
  type: state => state.user.type,
  links: state => state.user.links
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js